<template>
  <RouterView v-if="isBareBones" />
  <component :is="layout" v-else />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import { LAYOUTS } from '../../app-constants/layout.constant';

const route = useRoute();

const isBareBones = computed(() => route.meta.layout === 'none');

const layout = computed(() => {
  const layoutName = route.meta.layout as string;
  const match = LAYOUTS[layoutName];
  return match ? match.component : 'div';
});
</script>
